

import img1 from '../images/coin/btc.png';
import img2 from '../images/coin/eth.png';
import img3 from '../images/coin/bnb.png';
import img4 from '../images/coin/tet.png';
import img5 from '../images/coin/sol.png';
import img6 from '../images/coin/ada.png';
import img7 from '../images/coin/avax.png';

import chart1 from '../images/icon/chart-up.png';
import chart2 from '../images/icon/chart-down.png';
const dataCoin = [
    {
        id: 1,
        icon: img1,
        name: 'Bitcoin',
        uint: 'BTC',
        price: '$56,623.54',
        sale: '+1.45%',
        cap: '$880,423,640,582',
        chart: chart1,
        class: 'up',
        
    },
    {
        id: 2,
        icon: img2,
        name: 'Ethereum',
        uint: 'ETH',
        price: '$56,623.54',
        sale: '-5.12%',
        cap: '$880,423,640,582',
        chart: chart2,
        class: 'down',
        
    },
    {
        id: 3,
        icon: img3,
        name: 'Binance',
        uint: 'BNB',
        price: '$56,623.54',
        sale: '-3.75%',
        cap: '$880,423,640,582',
        chart: chart2,
        class: 'down',
        
    },
    {
        id: 4,
        icon: img4,
        name: 'Tether',
        uint: 'USDT',
        price: '$56,623.54',
        sale: '+1.45%',
        cap: '$880,423,640,582',
        chart: chart1,
        class: 'up',
        
    },
    {
        id: 5,
        icon: img5,
        name: 'Solana',
        uint: 'SOL',
        price: '$56,623.54',
        sale: '+1.45%',
        cap: '$880,423,640,582',
        chart: chart1,
        class: 'up',
        
    },
    {
        id: 6,
        icon: img1,
        name: 'XRP',
        uint: 'XRP',
        price: '$56,623.54',
        sale: '-2.22%',
        cap: '$880,423,640,582',
        chart: chart2,
        class: 'down',
        
    },
    {
        id: 7,
        icon: img6,
        name: 'XRP',
        uint: 'XRP',
        price: '$56,623.54',
        sale: '-2.22%',
        cap: '$880,423,640,582',
        chart: chart1,
        class: 'up',
        
    },
    {
        id: 8,
        icon: img7,
        name: 'Cardano',
        uint: 'ADA',
        price: '$56,623.54',
        sale: '+0.8%',
        cap: '$880,423,640,582',
        chart: chart1,
        class: 'up',
        
    },
   
]

export default dataCoin;